import type { Enum } from '../types';

export const IdpClientProducts = {
  UCL: 'UCL',
  UWCL: 'UWCL',
  UECL: 'UECL',
  UEL: 'UEL',
  NTC: 'NTC',
} as const;
export type IdpClientProducts = Enum<typeof IdpClientProducts>;

export enum CompetionsManaged {
  UCL = '1',
  UWCL = '28',
  UECL = '2019',
  UEL = '14',
  NTC = '3', //EURO
}

export type IdpAcquisitionSettings = {
  regCampaign?: string;
  regProduct?: IdpClientProducts;
};

export type IdpAnalyticsSettings = {
  ga_client_id?: string;
  ga_session_id?: string;
};

export interface IdpWebClientSettings {
  acquisitionSettings?: IdpAcquisitionSettings;
  analyticsSettings?: IdpAnalyticsSettings;

  /** The client application's identifier as registered with the OIDC/OAuth2 */
  client_id: string;
  /** The scope being requested from the OIDC/OAuth2 provider (default: "openid") */
  scope?: string;
  /** The return URI of the client application to redirect back after a successful response from the OIDC/OAuth2 provider.
   * if not provided, it will be the host location.origin
   */
  return_uri: string;
  locale?: string;
}

export const IdpRequestType = {
  Redirect: 'redirect',
  Popup: 'popup',
  Silent: 'silent',
};
export type IdpRequestType = Enum<typeof IdpRequestType>;

export type IdpAuthSettings = {
  requestType?: IdpRequestType;
  prompt?: string;
  locale?: string;
  scope?: string;
  policyId?: string;
};

export type Result<T, E> = {
  success: boolean;
  value?: T;
  error?: E;
};

export interface IdpError {
  message: string;
  code?: string;
}

export type Fan = {
  sub: string;
  uefaId?: string;
  email?: string;
  photoURL?: string;
  uefa_country_code?: string;

  nickname?: string;
  given_name?: string;
  middle_name?: string;
  family_name?: string;

  /*Favourite men national team */
  national_team_men?: number[];
  /*Favourite women national team */
  national_team_women?: number[];
  /*Favourite men club team */
  club_men?: number[];
  /*Favourite women club team */
  club_women?: number[];
  /* list of favourite leagues */
  leagues?: number[];

  favUclQualifiedTeams?: number[];
  interested_in_teams?: number[];
  [key: string]: unknown;
};

export const UserEvents = {
  LOGIN: 'login',
  LOGOUT: 'logout',
  LOGIN_SILENT: 'loginSilent',
  FAN_LOADED: 'fanLoaded',
  FAN_UPDATED: 'fanUpdated',
  TOKEN_EXPIRED: 'tokenExpired',
  UNAUTHORIZED: 'UnAuthorized',
  FAN_CENTER_CLOSED: 'fanCenterClosed',
  ERROR: 'error',
} as const;
export type UserEvents = Enum<typeof UserEvents>;

export interface IdpEventEmitter {
  on(event: UserEvents, callback: (e?: any) => void): IdpEventEmitter;
  off(event: UserEvents, callback: (e?: any) => void): IdpEventEmitter;
  once(event: UserEvents, callback: (e?: any) => void): IdpEventEmitter;
  emit(event: UserEvents, ...args: unknown[]): IdpEventEmitter;
}
